import orm, { State } from 'models/orm'
import { OrmState } from 'redux-orm'
import { createSelector } from 'reselect'
import { Customer } from 'types/customer'

export const selectAllCustomers = createSelector(
  [(state: { orm: OrmState<State> }) => state.orm],
  (ormState): Customer[] => {
    const session = orm.session(ormState)
    return session.Customer.all()
      .toModelArray()
      .map((customer: any) => ({
        id: customer.id,
        customer_name: customer.customer_name,
        customer_email: customer.customer_email,
        lifetime_spend: customer.lifetime_spend,
        days_since_last_visit: customer.days_since_last_visit,
        loyalty_tier: customer.loyalty_tier,
      }))
  }
)

export const selectCustomerById = (customerId: string) =>
  createSelector(
    [(state: { orm: OrmState<State> }) => state.orm],
    (ormState): Customer | undefined => {
      if (!customerId) return undefined

      const session = orm.session(ormState)
      try {
        const customer = session.Customer.withId(customerId)
        return customer
          ? {
              id: customer.id,
              customer_name: customer.customer_name,
              customer_email: customer.customer_email,
              lifetime_spend: customer.lifetime_spend,
              days_since_last_visit: customer.days_since_last_visit,
              loyalty_tier: customer.loyalty_tier,
            }
          : undefined
      } catch {
        return undefined
      }
    }
  )
